import React from 'react';

/**
 * Gleiche Titelhierarchie für die Haupt-Tabs. `unsichtbar`: die Seite heißt wie der markierte
 * Navigationspunkt (Events, News, Meine Events), ein sichtbarer Titel wiederholte ihn nur. Die
 * Überschrift bleibt für Screenreader und Suchmaschinen im Dokument.
 */
export default function TabPageHeading({ children, unsichtbar }: { children: React.ReactNode; unsichtbar?: boolean }) {
  return <h1 className={unsichtbar ? 'sr-only' : 'tab-page-title'}>{children}</h1>;
}
